// TextSOdkazy — prostý text, ve kterém se webové adresy (https://…, www.…)
// vykreslí jako proklikávací odkaz do nové záložky. Zbytek textu zůstává
// jak je, včetně zalomení řádků (rodič má whitespace-pre-wrap).
// Použití: <TextSOdkazy text={poznamka.text} />  (16.9.2026, poznámky v meetingu)
import React from "react";

const ODKAZ = /((?:https?:\/\/|www\.)[^\s<>"']+)/gi;

// Interpunkce na konci věty k odkazu nepatří ("…/view?usp=drive_link." → tečka zůstane textem).
function oddelKoncovouInterpunkci(url) {
  let u = url;
  let ocas = "";
  while (u.length) {
    const z = u[u.length - 1];
    if (!".,;:!?)]".includes(z)) break;
    if (z === ")") {
      const otevrene = u.split("(").length - 1;
      const zavrene = u.split(")").length - 1;
      if (otevrene >= zavrene) break;
    }
    ocas = z + ocas;
    u = u.slice(0, -1);
  }
  return [u, ocas];
}

export default function TextSOdkazy({ text, className = "" }) {
  const s = String(text == null ? "" : text);
  if (!ODKAZ.test(s)) return <>{s}</>;
  ODKAZ.lastIndex = 0;
  const casti = s.split(ODKAZ);
  return (
    <>
      {casti.map((cast, i) => {
        if (i % 2 === 0) return cast ? <React.Fragment key={i}>{cast}</React.Fragment> : null;
        const [url, ocas] = oddelKoncovouInterpunkci(cast);
        const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
        return (
          <React.Fragment key={i}>
            <a href={href} target="_blank" rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              draggable={false}
              className={`underline underline-offset-2 text-brand-700 hover:text-brand-800 break-all ${className}`}>
              {url}
            </a>
            {ocas}
          </React.Fragment>
        );
      })}
    </>
  );
}
